import React from "react";
import styles from "./FalconS.module.css";

import FalconS01 from "../../../assets/brochure/falcons/FalconS_01.png";

import FalconS02 from "../../../assets/brochure/falcons/팔콘_S_02.webp";

import FalconS03 from "../../../assets/brochure/falcons/팔콘_S_03.webp";

import FalconS04 from "../../../assets/brochure/falcons/팔콘_S_04.webp";

import FalconSAsset3 from "../../../assets/brochure/falcons/Asset 3.webp";
import FalconSAsset4 from "../../../assets/brochure/falcons/Asset 4.webp";
import FalconSAsset5 from "../../../assets/brochure/falcons/Asset 5.webp";
import FalconSAsset7 from "../../../assets/brochure/falcons/Asset 7.webp";
import FalconSAsset8 from "../../../assets/brochure/falcons/Asset 8.webp";

import FalconSAsset11 from "../../../assets/brochure/falcons/Asset 11.webp";
import FalconSAsset12 from "../../../assets/brochure/falcons/Asset 12.webp";
import FalconSAsset13 from "../../../assets/brochure/falcons/Asset 13.webp";
import FalconSAsset14 from "../../../assets/brochure/falcons/Asset 14.webp";
import FalconSAsset15 from "../../../assets/brochure/falcons/Asset 15.webp";
import FalconSAsset16 from "../../../assets/brochure/falcons/Asset 16.webp";
import FalconSAsset17 from "../../../assets/brochure/falcons/Asset 17.webp";
import FalconSAsset18 from "../../../assets/brochure/falcons/Asset 18.webp";



import FalconSAsset28 from "../../../assets/brochure/falcons/Asset 28.webp";
import FalconSAsset29 from "../../../assets/brochure/falcons/Asset 29.webp";
import FalconSAsset30 from "../../../assets/brochure/falcons/Asset 30.webp";
import FalconSAsset31 from "../../../assets/brochure/falcons/Asset 31.webp";
import FalconSAsset32 from "../../../assets/brochure/falcons/Asset 32.webp";
import FalconSAsset33 from "../../../assets/brochure/falcons/Asset 33.webp";



import FalconSAsset35 from "../../../assets/brochure/falcons/Asset 35.webp";
import FalconSAsset36 from "../../../assets/brochure/falcons/Asset 36.webp";
import FalconSAsset37 from "../../../assets/brochure/falcons/Asset 37.webp";

import FalconSAsset39 from "../../../assets/brochure/falcons/Asset 39.webp";
import FalconSAsset40 from "../../../assets/brochure/falcons/Asset 40.webp";
import FalconSAsset41 from "../../../assets/brochure/falcons/Asset 41.webp";
import FalconSAsset42 from "../../../assets/brochure/falcons/Asset 42.webp";
import FalconSAsset43 from "../../../assets/brochure/falcons/Asset 43.webp";
import FalconSAsset44 from "../../../assets/brochure/falcons/Asset 44.webp";
import FalconSAsset45 from "../../../assets/brochure/falcons/Asset 45.webp";
import FalconSAsset46 from "../../../assets/brochure/falcons/Asset 46.webp";

import FalconSAsset47 from "../../../assets/brochure/falcons/Asset 47.webp";

import FalconSAsset48 from "../../../assets/brochure/falcons/Asset 48.webp";
import FalconSAsset49 from "../../../assets/brochure/falcons/Asset 49.webp";
import FalconSAsset50 from "../../../assets/brochure/falcons/Asset 50.webp";
import FalconSAsset51 from "../../../assets/brochure/falcons/Asset 51.webp";
import FalconSAsset52 from "../../../assets/brochure/falcons/Asset 52.webp";
import FalconSAsset53 from "../../../assets/brochure/falcons/Asset 53.webp";
import FalconSAsset54 from "../../../assets/brochure/falcons/Asset 54.webp";
import FalconSAsset55 from "../../../assets/brochure/falcons/Asset 55.webp";
import FalconSAsset56 from "../../../assets/brochure/falcons/Asset 56.webp";
import FalconSAsset57 from "../../../assets/brochure/falcons/Asset 57.webp";
import FalconSAsset58 from "../../../assets/brochure/falcons/Asset 58.webp";
import FalconSAsset59 from "../../../assets/brochure/falcons/Asset 59.webp";
import FalconSAsset60 from "../../../assets/brochure/falcons/Asset 60.webp";
import FalconSAsset61 from "../../../assets/brochure/falcons/Asset 61.webp";
import FalconSAsset62 from "../../../assets/brochure/falcons/Asset 62.webp";
import FalconSAsset63 from "../../../assets/brochure/falcons/Asset 63.webp";
import FalconSAsset64 from "../../../assets/brochure/falcons/Asset 64.webp";
import FalconSAsset65 from "../../../assets/brochure/falcons/Asset 65.webp";

import FalconS07 from "../../../assets/brochure/falcons/FalconS_07.jpg";


const FalconS = () => {
  return (
    <article className={styles.falconSBrochure}>
      
      <section className={styles.heroSection}>
        <img
          src={FalconS01}
          alt="FALCON S Compact & Perfect massage chair"
          className={styles.heroImage}
        />
      </section>
      
<section
  className={styles.page02}
  aria-labelledby="falcons-page02-title"
>
  <img
    src={FalconS02}
    alt=""
    aria-hidden="true"
    className={styles.page02Background}
  />

  <div className={styles.page02Content}>
    <h2 id="falcons-page02-title">
      COMPACT HEALTH CARE ROBOT, FALCON S
    </h2>

    <div className={styles.page02Description}>
      <p>NOW, EXPERIENCE COMPLETE HOME</p>
      <p>CARE WITHOUT ‘TAKING UP SPACE.’</p>
    </div>
  </div>
</section>


<section
  className={styles.page03}
  aria-labelledby="falcons-page03-title"
>
  <img
    src={FalconS03}
    alt=""
    aria-hidden="true"
    className={styles.page03Background}
  />

  
  <div className={styles.page03Size}>
    <h2 id="falcons-page03-title">Size</h2>

    <p className={styles.page03SmallText}>
      IT’S TIME TO CHANGE THE BIASED
      <br />
      VIEW THAT MASSAGE CHAIRS CAN
      <br />
      ONLY BE USED IN SPACIOUS HOMES.
    </p>

    <h3>
      COMPACTLY WITHOUT
      <br />
      PROBLEM EVEN IN SMALL SPACES!
    </h3>
  </div>

  
  <div className={styles.page03Efficiency}>
    <p>
      FALCON S is the smallest massage chair among healthcare
      <br />
      robot products. Compact in size, yet fully packed with robotics
      <br />
      technology.
    </p>
  </div>

  
  <div className={styles.page03Design}>
    <h2>Design</h2>

    <p className={styles.page03SmallText}>
      PERFECT HARMONY OF GEOMETRIC
      <br />
      PENTAGON WINGS AND ERGONOMIC
      <br />
      DESIGN
    </p>

    <h3>USE AS AN INTERIOR POINT.</h3>
  </div>

  <div className={styles.page03DesignDescription}>
    <p>
      The ‘Pentagon Wing’ is in refined <strong>metallic</strong>
      <br />
      <strong>brown color</strong> with a delicate satin gloss.
      <br />
      The design catches the eye with a modern
      <br />
      sensibility and futuristic mood.
    </p>
  </div>

  
  <div className={styles.page03Durability}>
    <h2>Durability</h2>

    <p className={styles.page03SmallText}>
      NATURAL LEATHER IS USED ON THE BACK
      <br />
      AND HEAD, THE MOST FRICTION-PRONE
      <br />
      AREAS, TO ENSURE LONG-LASTING USE.
    </p>

    <h3>
      MORE ROBUST
      <br />
      DURABILITY WITH THE
      <br />
      USE OF NATURAL LEATHER!
    </h3>
  </div>

  <div className={styles.page03BottomDescription}>
    <p>
      Cozy touch and delicate softness
      <br />
      FALCON S is made of natural leather for
      <br />
      added durability and comfortable sitting.
    </p>
  </div>
</section>




<section
  className={styles.page04}
  aria-labelledby="falcons-page04-technology-title"
>
  
  <div className={styles.page04Intro}>
    <img
      src={FalconS04}
      alt=""
      aria-hidden="true"
      className={styles.page04IntroBackground}
    />

    <div className={styles.page04Technology}>
      <h2 id="falcons-page04-technology-title">
        Technology
      </h2>

      <p className={styles.page04TechnologyDescription}>
        INDEPENDENT LEFT AND RIGHT LEG
        <br />
        DRIVES PROVIDE A MORE ADVANCED
        <br />
        MASSAGE EXPERIENCE.
      </p>

      <h3>
        THE HEALTHCARE ROBOT
        <br />
        PROVIDES A DYNAMIC
        <br />
        MASSAGE EXPERIENCE!
      </h3>
    </div>
  </div>

  
  <div className={styles.page04Perfect01}>
    <div className={styles.page04PerfectHeading}>
      <span>PERFECT 01</span>
      <p>ROBOWALKING TECHNOLOGY</p>
    </div>

    
    <div className={styles.page04Feature01}>
      <span className={styles.page04FeatureNumber}>1</span>

      <h3>DYNAMIC! ROBOTICS MASSAGE</h3>

      <p className={styles.page04FeatureText}>
        BODYFRIEND’s proprietary robotics technology,
        <br />
        which drives left and right legs independently, is applied.
      </p>

      <div className={styles.page04RobotArea}>
        <img
          src={FalconSAsset3}
          alt="Falcon S independent leg robotics massage system"
          className={styles.page04RobotImage}
        />

        <div className={styles.page04RobotSpecs}>
          <p className={styles.page04UpgradeText}>
            WITH FURTHER UPGRADED
            <br />
            TECHNOLOGY, <strong>INCREASED</strong>
            <br />
            <strong>STRETCH EFFECT!</strong>
          </p>

          <div className={styles.page04Spec}>
            <img
              src={FalconSAsset4}
              alt=""
              aria-hidden="true"
            />

            <div>
              <span>WIDER LEG RANGE OF MOTION</span>

              <p>
                65°
                <small>(previously)</small>

                <b> 〉 </b>

                <strong>71° FALCON S</strong>
              </p>
            </div>
          </div>

          <div className={styles.page04Spec}>
            <img
              src={FalconSAsset5}
              alt=""
              aria-hidden="true"
            />

            <div>
              <span>ROBO LEG SPEED DOUBLY ENHANCED</span>

              <p>
                6mm/s
                <small>(previously)</small>

                <b> 〉 </b>

                <strong>12mm/s FALCON S</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    
<div className={styles.page04Feature02}>
  <span className={styles.page04FeatureNumber}>2</span>

  <h3>
    ENJOY CORE MUSCLE STRETCH WITH
    <br />
    FREEDOM OF BOTH LEGS.
  </h3>

  <p className={styles.page04FeatureText}>
    Free leg movements provide a full body
    <br />
    massage, stretch core muscles, and relax
    <br />
    major lower body muscles.
  </p>

  <img
    src={FalconSAsset7}
    alt=""
    aria-hidden="true"
    className={styles.page04Feature02Icon}
  />

  <img
    src={FalconSAsset8}
    alt="Falcon S core muscle stretch massage"
    className={styles.page04StretchImage}
  />
</div>
  </div>
<section className={styles.page04Feature03}>
  <span className={styles.page04FeatureNumber}>3</span>

  <h3>8 NEW ROBO CARE FEATURES</h3>

  <div className={styles.page04CareGrid}>

    
    <div className={styles.page04CareItem}>
      <img
        src={FalconSAsset11}
        alt="Iliopsoas relaxation"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>1</span>
          <h4>ILIOPSOAS<br />RELAXATION</h4>
        </div>

        <p>
          This care helps relax and stretch the iliopsoas muscle,
          which is prone to stiffness from prolonged sitting.
        </p>
      </div>
    </div>


    
    <div className={styles.page04CareItem}>
      <img
        src={FalconSAsset12}
        alt="Cycling exercise"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>2</span>
          <h4>CYCLING<br />EXERCISE</h4>
        </div>

        <p>
          Cycling motions are implemented in this massage care mode
          to enhance lower body flexibility.
        </p>
      </div>
    </div>


    
    <div
      className={`${styles.page04CareItem} ${styles.page04CareItemWide}`}
    >
      <img
        src={FalconSAsset13}
        alt="Full body stretch"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>3</span>
          <h4>FULL BODY STRETCH</h4>
        </div>

        <p>
          This care supports the back of the head and pulls the lower
          body to firmly stretch the spine along with a massage around
          the spine.
        </p>
      </div>
    </div>


    
    <div className={`${styles.page04CareItem} ${styles.page04CareReverse}`}>
      <img
        src={FalconSAsset14}
        alt="Lower body stretch"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>4</span>
          <h4>LOWER BODY<br />STRETCH</h4>
        </div>

        <p>
          This care supports the pelvis and pulls the lower body in for
          an intense stretch that focuses on the lower body.
        </p>
      </div>
    </div>


    
    <div className={`${styles.page04CareItem} ${styles.page04CareReverse}`}>
      <img
        src={FalconSAsset15}
        alt="Piriformis relaxation"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>5</span>
          <h4>PIRIFORMIS<br />RELAXATION</h4>
        </div>

        <p>
          This care relaxes and increases the flexibility of the
          piriformis muscle, which supports the muscles at the back
          of the butt.
        </p>
      </div>
    </div>


    
    <div className={styles.page04CareItem}>
      <img
        src={FalconSAsset16}
        alt="PNF stretch"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>6</span>
          <h4>PNF STRETCH</h4>
        </div>

        <p>
          Voice-guided care to increase the vitality of lower body muscles.
        </p>
      </div>
    </div>


    
    <div className={styles.page04CareItem}>
      <img
        src={FalconSAsset17}
        alt="Robo refresh"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>7</span>
          <h4>ROBO REFRESH</h4>
        </div>

        <p>
          This care applies cool acupressure in areas where fatigue
          accumulates greatly to increase vitality.
        </p>
      </div>
    </div>


    
    <div className={styles.page04CareItem}>
      <img
        src={FalconSAsset18}
        alt="Robo recovery"
        className={styles.page04CareImage}
      />

      <div className={styles.page04CareContent}>
        <div className={styles.page04CareHeading}>
          <span>8</span>
          <h4>ROBO RECOVERY</h4>
        </div>

        <p>
          This care gently applies acupressure mainly on the neck and
          back and lets them move to relieve fatigue.
        </p>
      </div>
    </div>

  </div>
</section>


</section>

<section
  className={styles.page05}
  aria-labelledby="falcons-page05-title"
>
  
  <header className={styles.page05Header}>
    <span className={styles.page05PerfectBadge}>
      PERFECT 02
    </span>

    <h2 id="falcons-page05-title">
      BODYFRIEND’S
      <br />
      TECHNOLOGY
    </h2>
  </header>


  
  <div className={styles.page05Feature}>
    <img
      src={FalconSAsset28}
      alt="Falcon S XD massage module"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>XD MASSAGE MODULE</h3>

      <p>
        5 LEVELS OF MASSAGE INTENSITY
        <br />
        AND 3 LEVELS OF ROLLER WIDTH PROVIDE
        <br />
        OPTIMIZED MASSAGE.
      </p>
    </div>
  </div>


  
  <div className={styles.page05Feature}>
    <img
      src={FalconSAsset29}
      alt="Falcon S hand acupressure pad"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>HAND ACUPRESSURE PAD</h3>

      <p>
        THE HAND ACUPRESSURE PADS MOUNTED
        <br />
        ON THE LEFT AND RIGHT ARM MASSAGERS
        <br />
        RELIEVE HAND FATIGUE.
      </p>

      <p className={styles.page05Patent}>
        * PATENT NO. 10-1779083: HAND ACUPRESSURE
        <br />
        TECHNOLOGY FOR THE MASSAGE DEVICE
      </p>
    </div>
  </div>


  
  <div className={styles.page05Feature}>
    <img
      src={FalconSAsset30}
      alt="Falcon S quick dial control"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>QUICK DIAL</h3>

      <p>
        EASILY CONTROLS POWER ON/OFF,
        <br />
        ROBO-CARE, AND UP TO THE FULL BODY ANGLE.
      </p>
    </div>
  </div>


  
  <div className={styles.page05Feature}>
    <img
      src={FalconSAsset31}
      alt="Falcon S three-level heating system"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>3-LEVEL HEATING</h3>

      <p>
        HEATING ON THE BACK AND CALVES PROVIDES
        <br />
        WARM MASSAGE ON THE UPPER AND LOWER BODIES.
      </p>
    </div>
  </div>


  
  <div className={styles.page05Feature}>
    <img
      src={FalconSAsset32}
      alt="Falcon S soft airbag massage system"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>SOFT AIRBAGS</h3>

      <p>
        36 AIRBAGS THOROUGHLY MASSAGE THE FULL
        <br />
        BODY FROM HANDS, ARMS, SHOULDERS, AND
        <br />
        CALVES UP TO HEELS.
      </p>
    </div>
  </div>


  
  <div className={`${styles.page05Feature} ${styles.page05FeatureLast}`}>
    <img
      src={FalconSAsset33}
      alt="Falcon S enhanced safety sensors"
      className={styles.page05FeatureImage}
    />

    <div className={styles.page05FeatureText}>
      <h3>MORE ENHANCED SAFETY SENSORS</h3>

      <p>
        14 SAFETY SENSORS ARE APPLIED ON
        <br />
        THE LEGS AND THE BACK FOR ADDED PEACE OF MIND.
      </p>
    </div>
  </div>
</section>

<section
  className={styles.page06}
  aria-labelledby="falcons-page06-title"
>
  
  <header className={styles.page06Header}>
    <h2 id="falcons-page06-title">FALCON·S</h2>

    <p>
      CONVENIENCE FEATURES THAT
      <br />
      FURTHER INCREASE MASSAGE QUALITY
    </p>

    <div className={styles.page06HeaderLine} />

    <h3>AUTOMATIC MASSAGE PROGRAM</h3>
  </header>

  
  <img
    src={FalconSAsset35}
    alt="Falcon S automatic massage program"
    className={styles.page06MainImage}
  />


  
  <section className={styles.page06CourseSection}>
    <h3>
      6 <strong>HEALTH CARE</strong> COURSES
    </h3>

    <div className={styles.page06HealthGrid}>
      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          
          <img
  src={FalconSAsset36}
  alt=""
  aria-hidden="true"
  className={styles.page06IconWithNew}
/>
        </div>

        <p>SPINE MODE</p>
        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          
          <img
  src={FalconSAsset37}
  alt=""
  aria-hidden="true"
  className={styles.page06IconWithNew}
/>
        </div>

        <p>SWELLING RELIEF</p>
        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset39} alt="" aria-hidden="true" />
        </div>

        <p>
          NAPE TENSION
          <br />
          RELIEF
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset40} alt="" aria-hidden="true" />
        </div>

        <p>
          COMFORTABLE
          <br />
          WAIST
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset41} alt="" aria-hidden="true" />
        </div>

        <p>
          HANGOVER
          <br />
          RELIEF
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset42} alt="" aria-hidden="true" />
        </div>

        <p>
          FULL BODY
          <br />
          RELAXATION
        </p>
      </article>
    </div>
  </section>


  
  <section
    className={`${styles.page06CourseSection} ${styles.page06TintSection}`}
  >
    <h3>
      4 <strong>PARTS CARE</strong> COURSES
    </h3>

    <div className={styles.page06FourGrid}>
      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset43} alt="" aria-hidden="true" />
        </div>

        <p>FULL BODY</p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset44} alt="" aria-hidden="true" />
        </div>

        <p>
          NECK/
          <br />
          SHOULDERS
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset45} alt="" aria-hidden="true" />
        </div>

        <p>
          WAIST/
          <br />
          BUTT
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset46} alt="" aria-hidden="true" />
        </div>

        <p>
          FEET/
          <br />
          LEGS
        </p>
      </article>
    </div>
  </section>


  
  <img
    src={FalconSAsset47}
    alt="Falcon S neck massage"
    className={styles.page06SecondaryImage}
  />


  
  <section className={styles.page06CourseSection}>
    <h3>
      8 <strong>DAILY CARE</strong> COURSES
    </h3>

    <div className={styles.page06FourGrid}>
      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset48} alt="" aria-hidden="true" />
        </div>

        <p>
          STUDENT'S NECK/
          <br />
          SHOULDERS
        </p>

        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset49} alt="" aria-hidden="true" />
        </div>

        <p>
          STUDENT
          <br />
          RELAXATION CARE
        </p>

        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset50} alt="" aria-hidden="true" />
        </div>

        <p>
          STUDENT
          <br />
          SPEED CARE
        </p>

        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          
          <img
  src={FalconSAsset51}
  alt=""
  aria-hidden="true"
  className={styles.page06IconWithNew}
/>
        </div>

        <p>
          STUDENT
          <br />
          STRETCH
        </p>

        <span className={styles.page06Stars}>★★★</span>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset52} alt="" aria-hidden="true" />
        </div>

        <p>DEEP SLEEP</p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset53} alt="" aria-hidden="true" />
        </div>

        <p>
          PRE/POST
          <br />
          WORKOUT
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset54} alt="" aria-hidden="true" />
        </div>

        <p>
          MORNING
          <br />
          VITALITY
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset55} alt="" aria-hidden="true" />
        </div>

        <p>
          DIGESTIVE
          <br />
          HEALTH
        </p>
      </article>
    </div>
  </section>


  
  <section
    className={`${styles.page06CourseSection} ${styles.page06TintSection}`}
  >
    <h3>
      4 <strong>MENTAL CARE</strong> COURSES
    </h3>

    <div className={styles.page06FourGrid}>
      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset56} alt="" aria-hidden="true" />
        </div>

        <p>CONSOLE</p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset57} alt="" aria-hidden="true" />
        </div>

        <p>
          BREATHE
          <br />
          CONTROL
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset58} alt="" aria-hidden="true" />
        </div>

        <p>
          MENTAL
          <br />
          IMAGERY
        </p>
      </article>

      
      <article className={styles.page06CourseItem}>
        <div className={styles.page06IconWrap}>
          <img src={FalconSAsset59} alt="" aria-hidden="true" />
        </div>

        <p>
          JOY OF
          <br />
          IMMERSION
        </p>
      </article>
    </div>
  </section>


  
  <section className={styles.page06ConvenienceList}>
    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset60}
        alt="Automatic body shape recognition"
      />

      <div>
        <h3>
          AUTOMATIC BODY
          <br />
          SHAPE RECOGNITION
        </h3>

        <p>
          The massage module’s
          <br />
          sensors recognize your
          <br />
          body shape to provide a
          <br />
          customized massage.
        </p>
      </div>
    </article>

    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset61}
        alt="Automatic leg length adjustment"
      />

      <div>
        <h3>
          AUTOMATIC LEG
          <br />
          LENGTH ADJUSTMENT
        </h3>

        <p>
          up to 18cm adjustment
          <br />
          provides comfortable
          <br />
          massage.
        </p>
      </div>
    </article>

    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset62}
        alt="Account creation by user"
      />

      <div>
        <h3>
          ACCOUNT CREATION
          <br />
          BY USER
        </h3>

        <p>
          You can save your favorite
          <br />
          massage options and modes.
        </p>
      </div>
    </article>

    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset63}
        alt="Bluetooth speaker"
      />

      <div>
        <h3>BLUETOOTH SPEAKER</h3>

        <p>
          Connect your smartphone
          <br />
          and listen to your favorite
          <br />
          music in the massage chair.
        </p>
      </div>
    </article>

    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset64}
        alt="Wireless software update"
      />

      <div>
        <h3>
          WIRELESS SOFTWARE
          <br />
          UPDATE
        </h3>

        <p>
          The Wi-Fi app enables
          <br />
          automatic updates without
          <br />
          a service technician.
        </p>
      </div>
    </article>

    
    <article className={styles.page06ConvenienceItem}>
      <img
        src={FalconSAsset65}
        alt="Automatic sliding angle adjustment"
      />

      <div>
        <h3>
          AUTOMATIC SLIDING
          <br />
          ANGLE ADJUSTMENT
        </h3>

        <p>
          Minimized back-space
          <br />
          installation increases the
          <br />
          efficiency of space utilization.
        </p>
      </div>
    </article>
  </section>
</section>


<section className={styles.page07}>
  <img
    src={FalconS07}
    alt="Falcon S brochure page 07"
    className={styles.page07Image}
  />
</section>
    </article>
  );
};

export default FalconS;